import { AnimatePresence, motion } from "framer-motion";
import type { CountryFeature, HoverPosition } from "../types";
import { getName, getCode, getContinent } from "../utils/country";

interface Props {
  feature: CountryFeature | null;
  position: HoverPosition | null;
}

export default function HoverCard({ feature, position }: Props) {
  const visible = feature && position;
  return (
    <AnimatePresence>
      {visible ? (
        <motion.div
          key={getCode(feature.properties)}
          className="hover-card"
          style={{
            left: position.x,
            top: position.y,
          }}
          initial={{ opacity: 0, y: 6, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -4, scale: 0.98 }}
          transition={{ duration: 0.18, ease: [0.2, 0.8, 0.2, 1] }}
        >
          <div className="hc-row">
            <span className="mono hc-code">{getCode(feature.properties)}</span>
            <span className="hc-bar" />
            <span className="mono hc-region">
              {getContinent(feature.properties)}
            </span>
          </div>
          <div className="hc-name">{getName(feature.properties)}</div>
          <div className="mono hc-hint">click to select ↗</div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
